import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant invisible qui synchronise l'URL avec les états React
 * Détecte le changement d'URL et appelle les fonctions de navigation appropriées
 */
const RouterSync = ({ propertyFormRef }) => {
  const location = useLocation();

  useEffect(() => {
    if (!propertyFormRef?.current) return;

    const path = location.pathname;
    const searchParams = new URLSearchParams(location.search);

    console.log('🔄 RouterSync - URL changed:', path);
    
    // IGNORER toutes les routes /properties/* (gérées par React Router canonique)
    if (path.startsWith('/properties')) {
      console.log('🔄 RouterSync - Ignoring /properties/* route');
      return;
    }

    // Synchroniser l'URL vers les états React
    const action = searchParams.get('action');
    
    // Gérer les actions sur la racine
    if ((path === '/' || path === '/dashboard') && action) {
      if (action === 'new' && propertyFormRef.current.startNewProperty) {
        propertyFormRef.current.startNewProperty();
      } else if (action === 'newContact' && propertyFormRef.current.startNewContact) {
        propertyFormRef.current.startNewContact();
      }
    } else if (path === '/' || path === '/dashboard') {
      // Dashboard sans paramètres
      propertyFormRef.current.showDashboardView?.();
    } else if (path === '/biens' || path.startsWith('/biens')) {
      // Liste des biens (legacy route)
      propertyFormRef.current.showPropertiesView?.();
      
      // Appliquer le filtre si présent
      const filter = searchParams.get('filter');
      if (filter && propertyFormRef.current.setCurrentFilter) {
        propertyFormRef.current.setCurrentFilter(filter);
      }
    } else if (path === '/contacts' || path.startsWith('/contacts')) {
      // Contacts
      propertyFormRef.current.showContactsView?.();
    } else if (path === '/demandes-contact') {
      // Demandes de contact
      propertyFormRef.current.showDemandesContactView?.();
    } else if (path === '/favoris') {
      // Favoris
      propertyFormRef.current.showFavoritesView?.();
    } else if (path.startsWith('/documents')) {
      // Documents (et sous-routes)
      propertyFormRef.current.showDocumentsView?.();
    } else if (path.startsWith('/marketing')) {
      // Marketing (et sous-routes)
      propertyFormRef.current.showMarketingView?.();
      // Gérer les sous-tabs marketing
      if (path === '/marketing/social' && propertyFormRef.current.setActiveMarketingTab) {
        propertyFormRef.current.setActiveMarketingTab('social');
      } else if (path === '/marketing/campaigns' && propertyFormRef.current.setActiveMarketingTab) {
        propertyFormRef.current.setActiveMarketingTab('campaigns');
      } else if (path === '/marketing/email' && propertyFormRef.current.setActiveMarketingTab) {
        propertyFormRef.current.setActiveMarketingTab('email');
      } else if (path === '/marketing/analytics' && propertyFormRef.current.setActiveMarketingTab) {
        propertyFormRef.current.setActiveMarketingTab('analytics');
      }
    } else if (path.startsWith('/outils')) {
      // Outils (et sous-routes)
      // Gérer les sous-tabs outils
      if (path === '/outils/avis-de-valeur') {
        propertyFormRef.current.showAvisDeValeurView?.();
      } else if (path === '/outils/simulateurs' && propertyFormRef.current.setActiveOutilsTab) {
        // iter.75 : entrée principale du menu Simulateurs (sidebar) → Dashboard.
        propertyFormRef.current.showOutilsView?.();
        propertyFormRef.current.setActiveOutilsTab('dashboard');
      } else if (path === '/outils/calculettes' && propertyFormRef.current.setActiveOutilsTab) {
        // iter.75 : `?calc=<id>` gère le focus sur une calculette précise.
        // Sans query, on ouvre la grille complète des calculettes.
        propertyFormRef.current.showOutilsView?.();
        propertyFormRef.current.setActiveOutilsTab('calculettes');
      } else if (path === '/outils/statistiques' && propertyFormRef.current.setActiveOutilsTab) {
        propertyFormRef.current.showOutilsView?.();
        propertyFormRef.current.setActiveOutilsTab('statistiques');
      } else {
        propertyFormRef.current.showOutilsView?.();
      }
    } else if (path === '/profil' || path.startsWith('/profil')) {
      // Profile
      propertyFormRef.current.showProfileView?.();
    } else if (path === '/settings' || path.startsWith('/settings')) {
      // Settings
      propertyFormRef.current.showSettingsView?.();
    }
  }, [location.pathname, location.search, propertyFormRef]);

  // Ce composant ne rend rien
  return null;
};

export default RouterSync;
